import {z} from 'zod';

export const SsoProviderSchema = z.enum(['oidc', 'saml', 'brevo']);
export type SsoProviderType = z.infer<typeof SsoProviderSchema>;
